"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins } from "vue-property-decorator";
import { PaymentPurchaseSelectedModel } from "@/models/paymentModels/PaymentPurchase.model";
import { AccountSessionMixins } from "@/service/account-session";
import API from "@ym-framework/api-utils";
const vipIcon = require("@/assets/midsafety/yundun.png");
const aliPayIcon = require("@/assets/img/pay_zfb.png");
const wechatPayIcon = require("@/assets/img/pay_wx.png");
import { Debounce } from "vue-debounce-decorator";
import DateFormat from "@/framework/timeformatter";
let PurchaseService = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.pageLoading = false;
    this.payLoading = false;
    //VIP图标
    this.vip_icon = vipIcon;
    // 支付图标
    this.alipay_icon = aliPayIcon;
    this.wechat_icon = wechatPayIcon;
    // 套餐相关数据
    this.productList = [];
    this.selectedProductData = new PaymentPurchaseSelectedModel();
    // 计算属性
    // 原价
    this.originalPrice = 0;
    // 折后价
    this.discountPrice = 0;
    // 应付金额
    this.payPrice = 0;
    // 购买类型
    this.purchaseType = "new";
    // 已有监管名额数量
    this.totalQuota = 0;
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.getProducts();
      if (this.$route.query && this.$route.query.type === "renew") {
        this.purchaseType = "renew";
        yield this.getUsedQuota();
      } else {
        this.purchaseType = "new";
      }
      yield this.calculations();
    });
  }
  getUsedQuota() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.auth/api/v1/regulation-quota-statistics`);
        this.totalQuota = response.data.totalQuota;
        this.selectedProductData.selectedAdditionalQuota = response.data.addQuota;
      } catch (error) {
      }
    });
  }
  changeQuota() {
    return __async(this, null, function* () {
      this.payLoading = true;
      yield this.calculations();
    });
  }
  checkDate(date) {
    let dateNow = Date.now();
    let dateAdd = new Date(dateNow).getTime() + date * 24 * 60 * 60 * 1e3;
    return DateFormat.dateformatterDay(DateFormat.check(dateAdd));
  }
  calculations() {
    return __async(this, null, function* () {
      try {
        yield this.getGoldbean();
        let calculateData = {
          discounts: [],
          coin: this.selectedProductData.paymentGoldbeanUsed,
          quantity: 1,
          payType: this.selectedProductData.paymentMethod,
          goodsSpecGuid: this.selectedProductData.id,
          type: "SAFETY_MANAGER_NEW"
        };
        if (this.selectedProductData.selectedAdditionalQuota > 0) {
          calculateData.additionalPurchase = [
            {
              "goodsSpecGuid": this.selectedProductData.selectedAdditionalId,
              "quantity": this.selectedProductData.selectedAdditionalQuota
            }
          ];
        }
        let response = yield API.post(`api://base.auth.pro/v1/calculate`, calculateData);
        this.calculationTidy(response.data);
        this.originalPrice = response.data.originalPrice;
        this.discountPrice = response.data.discountPrice;
        this.payPrice = response.data.payPrice;
      } catch (error) {
      } finally {
        this.payLoading = false;
      }
    });
  }
  calculationTidy(data) {
    return __async(this, null, function* () {
      this.selectedProductData.paymentGoldbeanUsed = this.selectedProductData.paymentGoldbeanUsed ? this.selectedProductData.paymentGoldbeanUsed : 0;
      this.selectedProductData.paymentGoldbeanLeft = this.selectedProductData.paymentGoldbeanCoins - data.coin;
      this.selectedProductData.paymentGoldbeanLimit = Math.min(
        data.maxCoin,
        this.selectedProductData.paymentGoldbeanCoins
      );
      if (this.selectedProductData.paymentGoldbeanUsed > this.selectedProductData.paymentGoldbeanLimit) {
        this.selectedProductData.paymentGoldbeanUsed = this.selectedProductData.paymentGoldbeanLimit;
      }
    });
  }
  getGoldbean() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(
          `api://base.auth/api/v7/payment/account/coins`
        );
        this.selectedProductData.paymentGoldbeanCoins = response.data.account_coins.coins;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  discountChange() {
    return __async(this, null, function* () {
      this.payLoading = true;
      yield this.calculations();
    });
  }
  payForGoldbean() {
    return __async(this, null, function* () {
      try {
        this.payLoading = true;
        if (this.selectedProductData.paymentGoldbeanCoins && this.selectedProductData.paymentGoldbeanCoins > 0) {
          if (this.selectedProductData.paymentGoldbeanLimit >= this.selectedProductData.paymentGoldbeanLeft) {
            this.selectedProductData.paymentGoldbeanUsed = this.selectedProductData.paymentGoldbeanLeft;
          } else {
            this.selectedProductData.paymentGoldbeanUsed = this.selectedProductData.paymentGoldbeanLimit;
          }
          yield this.calculations();
        } else {
          this.payLoading = false;
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  goBack() {
    this.$router.go(-1);
  }
  selectPackage(productItem) {
    return __async(this, null, function* () {
      this.payLoading = true;
      this.selectedProductData.id = productItem.id;
      this.selectedProductData.selectedProduct = productItem;
      this.selectedProductData.selectedAdditionalId = productItem.additionalPurchase[0].id;
      yield this.calculations();
    });
  }
  toCost() {
    let router = this.$router.resolve("/cost");
    window.open(router.href, "_blank");
  }
  selectPayment(method) {
    this.selectedProductData.paymentMethod = method;
  }
  // 获取商品列表
  getProducts() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.auth/api/v8/goods/safety_manager/purchase`);
        this.productList = response.data.datas;
        this.selectedProductData.id = response.data.datas[0].id;
        this.selectedProductData.selectedProduct = response.data.datas[0];
        this.selectedProductData.selectedAdditionalId = response.data.datas[0].additionalPurchase[0].id;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  // 去支付
  payNow() {
    return __async(this, null, function* () {
      this.payLoading = true;
      yield this.createOrder();
    });
  }
  createOrder() {
    return __async(this, null, function* () {
      var _a, _b, _c;
      try {
        const orderData = {
          "callback": "https://app.kuajingvs.com/paymentcomplete",
          "discounts": [
            {
              "type": "point",
              "value": this.selectedProductData.paymentGoldbeanUsed
            }
          ],
          "pay_type": this.selectedProductData.paymentMethod,
          "product": {
            "goods_spec_guid": this.selectedProductData.id
          },
          "autoRenew": this.selectedProductData.selectedautoRenewal,
          "quantity": 1,
          "user_input": {}
        };
        if (this.selectedProductData.selectedAdditionalQuota && this.selectedProductData.selectedAdditionalQuota > 0) {
          orderData.additionalPurchase = [
            {
              "goodsSpecGuid": this.selectedProductData.selectedAdditionalId,
              "quantity": this.selectedProductData.selectedAdditionalQuota
            }
          ];
        }
        if (this.purchaseType === "renew") {
          if ((_a = this.$session) == null ? void 0 : _a.marks.is("SAFETY_MANAGER_CHARGE")) {
            let response = yield API.post(`api://base.auth/api/v8/orders/safety_manager/renew/pay`, orderData);
            this.selectedProductData.paymentGoldbeanUsed = 0;
            let model = response.data;
            if (model.order) {
              model.gift = model.order.pay_money <= 0;
            } else {
              model.gift = false;
            }
            let _order_id = model.order.id;
            let _qr_url = model.url;
            let _gift = model.gift;
            switch (this.selectedProductData.paymentMethod) {
              case "alipay":
                this.$router.push({
                  name: "PaymentPurchaseConfirmation",
                  query: {
                    t: "alipay",
                    r: "",
                    id: _order_id,
                    qr: _qr_url,
                    gift: _gift,
                    style: "renew"
                  }
                });
                break;
              case "wxpay":
                this.$router.push({
                  name: "PaymentPurchaseConfirmation",
                  query: {
                    t: "wechat",
                    r: "",
                    id: _order_id,
                    qr: _qr_url,
                    gift: _gift,
                    style: "renew"
                  }
                });
                break;
            }
          } else if ((_b = this.$session) == null ? void 0 : _b.marks.is("SAFETY_MANAGER_TRIAL")) {
            let response = yield API.post(`api://base.auth/api/v8/orders/safety_manager/upgrade/pay`, orderData);
            this.selectedProductData.paymentGoldbeanUsed = 0;
            let model = response.data;
            if (model.order) {
              model.gift = model.order.pay_money <= 0;
            } else {
              model.gift = false;
            }
            let _order_id = model.order.id;
            let _qr_url = model.url;
            let _gift = model.gift;
            switch (this.selectedProductData.paymentMethod) {
              case "alipay":
                this.$router.push({
                  name: "PaymentPurchaseConfirmation",
                  query: {
                    t: "alipay",
                    r: "",
                    id: _order_id,
                    qr: _qr_url,
                    gift: _gift,
                    style: "upgrade"
                  }
                });
                break;
              case "wxpay":
                this.$router.push({
                  name: "PaymentPurchaseConfirmation",
                  query: {
                    t: "wechat",
                    r: "",
                    id: _order_id,
                    qr: _qr_url,
                    gift: _gift,
                    style: "upgrade"
                  }
                });
                break;
            }
          }
        } else {
          if ((_c = this.$session) == null ? void 0 : _c.marks.is("SAFETY_MANAGER_TRIAL")) {
            let response = yield API.post(`api://base.auth/api/v8/orders/safety_manager/upgrade/pay`, orderData);
            this.selectedProductData.paymentGoldbeanUsed = 0;
            let model = response.data;
            if (model.order) {
              model.gift = model.order.pay_money <= 0;
            } else {
              model.gift = false;
            }
            let _order_id = model.order.id;
            let _qr_url = model.url;
            let _gift = model.gift;
            switch (this.selectedProductData.paymentMethod) {
              case "alipay":
                this.$router.push({
                  name: "PaymentPurchaseConfirmation",
                  query: {
                    t: "alipay",
                    r: "",
                    id: _order_id,
                    qr: _qr_url,
                    gift: _gift,
                    style: "upgrade"
                  }
                });
                break;
              case "wxpay":
                this.$router.push({
                  name: "PaymentPurchaseConfirmation",
                  query: {
                    t: "wechat",
                    r: "",
                    id: _order_id,
                    qr: _qr_url,
                    gift: _gift,
                    style: "upgrade"
                  }
                });
                break;
            }
          } else {
            let response = yield API.post(`api://base.auth/api/v8/orders/safety_manager/new/pay`, orderData);
            this.selectedProductData.paymentGoldbeanUsed = 0;
            let model = response.data;
            if (model.order) {
              model.gift = model.order.pay_money <= 0;
            } else {
              model.gift = false;
            }
            let _order_id = model.order.id;
            let _qr_url = model.url;
            let _gift = model.gift;
            switch (this.selectedProductData.paymentMethod) {
              case "alipay":
                this.$router.push({
                  name: "PaymentPurchaseConfirmation",
                  query: {
                    t: "alipay",
                    r: "",
                    id: _order_id,
                    qr: _qr_url,
                    gift: _gift,
                    style: "new"
                  }
                });
                break;
              case "wxpay":
                this.$router.push({
                  name: "PaymentPurchaseConfirmation",
                  query: {
                    t: "wechat",
                    r: "",
                    id: _order_id,
                    qr: _qr_url,
                    gift: _gift,
                    style: "new"
                  }
                });
                break;
            }
          }
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.payLoading = false;
      }
    });
  }
};
__decorateClass([
  Debounce(400)
], PurchaseService.prototype, "calculations", 1);
__decorateClass([
  Debounce(400)
], PurchaseService.prototype, "createOrder", 1);
PurchaseService = __decorateClass([
  Component({
    components: {},
    filters: {
      numFilter: (value) => {
        if (value === "-") {
          return value;
        }
        return Number(value).toFixed(2);
      }
    }
  })
], PurchaseService);
export {
  PurchaseService as default
};
